const Alert = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return {
        backgroundColor: "var(--palette-grid_header)",
      };
    },
    standardSuccess: ({ ownerState, theme }) => ({
      color: "var(--palette-success)",
      backgroundColor: "var(--palette-success_bg)",
      "& .MuiAlert-icon": {
        color: "var(--palette-success)",
      },
    }),
    standardInfo: ({ ownerState, theme }) => ({
      color: "var(--palette-info)",
      backgroundColor: "var(--palette-info_bg)",
      "& .MuiAlert-icon": {
        color: "var(--palette-grey_text)",
      },
    }),
    standardWarning: ({ ownerState, theme }) => ({
      color: "var(--palette-warning)",
      backgroundColor: "var(--palette-warning_bg)",
      "& .MuiAlert-icon": {
        color: "var(--palette-warning)",
      },
    }),
    standardError: ({ ownerState, theme }) => ({
      color: "var(--palette-error)",
      backgroundColor: "var(--palette-error_bg)",
      "& .MuiAlert-icon": {
        color: "var(--palette-error)",
      },
    }),
  },
};

export default Alert;
